import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  standalone: false,
  selector: 'invd-enter-balances-interest-review-error',
  templateUrl: './enter-balances-interest-review-error.component.html',
  styleUrls: ['./enter-balances-interest-review-error.component.scss'],
})
export class EnterBalancesInterestReviewErrorComponent {
  @Input() statusTitle: string;
  @Input() statusDisplayMessage: string;
  @Input() statusResolutionMessage: string;
  @Input() modalHasStatusSuccess: boolean;
  @Input() modalHasStatusError: boolean;
  @Input() SMBSFlowModifyExchange: boolean;
  @Input() principalMismatch: boolean;
  @Input() interestMismatch: boolean;
  @Input() isRCRFLOW: boolean;
  @Input() rcrCalcFeeErrorRes: any;
  @Input() totalErrorCount: number;
  @Input() netExchangeViews: any[];
  @Input() rcrRemicDealType: string;
  @Output() buttonClicked = new EventEmitter<boolean>();
  public isSMBS = true;
  public recomNumber = 0;
  public errorCountVal = 1;

  protected onButtonClicked(clicked: boolean): void {
    this.buttonClicked.emit(clicked);
  }

  public showRecombination(val: string): void {
    if (val === 'increment') {
      this.errorCountVal =
        this.errorCountVal < this.totalErrorCount
          ? this.errorCountVal + 1
          : this.errorCountVal >= this.totalErrorCount
            ? this.errorCountVal
            : this.errorCountVal;
      this.recomNumber =
        val === 'increment' && this.recomNumber < this.totalErrorCount - 1
          ? this.recomNumber + 1
          : this.recomNumber;
    } else if (val === 'decrement') {
      this.errorCountVal =
        this.errorCountVal > 1
          ? this.errorCountVal - 1
          : this.errorCountVal <= 1
            ? this.errorCountVal
            : this.errorCountVal;
      this.recomNumber =
        val === 'decrement' && this.recomNumber > 0 ? this.recomNumber - 1 : this.recomNumber;
    }
  }

  protected trackByIdentity(_index: number, obj: any) {
    return obj;
  }
}
